/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface IntegrationPersonRegisteredPersonIdGet$Params {

/**
 * The unique identifier of the person
 */
  personId: string;
}

export function integrationPersonRegisteredPersonIdGet(http: HttpClient, rootUrl: string, params: IntegrationPersonRegisteredPersonIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, integrationPersonRegisteredPersonIdGet.PATH, 'get');
  if (params) {
    rb.path('personId', params.personId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as VivaLiteScanStrictHttpResponse<boolean>;
    })
  );
}

integrationPersonRegisteredPersonIdGet.PATH = '/Integration/PersonRegistered/{personId}';
